export class HTTPException extends Error {
    constructor(status, statusText, data) {
        super(`${status} ${statusText}`);
        this.status = status;
        this.statusText = statusText;
        this.data = data;
    }
}
export const parseResponse = (response) => {
    var _a;
    if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
        return response.json().then((data) => {
            if (response.ok) {
                return data;
            }
            throw new HTTPException(response.status, response.statusText, data);
        });
    }
    if (response.ok) {
        if (response.status === 204) {
            return null;
        }
        return response.text();
    }
    throw new HTTPException(response.status, response.statusText, null);
};
export const getErrorMessage = (error) => {
    var _a;
    if (error instanceof HTTPException && 'message' in error.data) {
        return (_a = error.data.message.split(':')[1]) === null || _a === void 0 ? void 0 : _a.trim();
    }
    return null;
};
export const generateGetKey = (query, size) => (pageIndex) => {
    if (!query)
        return '';
    return [query, `page=${pageIndex}&size=${size}`].join(query.includes('?') ? '&' : '?');
};
export const createFetch = (baseUrl, authTokenResolver, defaultHeaders = {}) => async (url, init = {}, options = {}) => {
    var _a;
    // ? INFO(suley) abort call after 8 secs, it is 300 seconds in chrome
    const timeout = options.timeout || 16000;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    const headers = new Headers({
        ...defaultHeaders,
        ...((_a = init === null || init === void 0 ? void 0 : init.headers) !== null && _a !== void 0 ? _a : {}),
    });
    if (!(options === null || options === void 0 ? void 0 : options.noDefaultHeader)) {
        headers.append('Content-Type', 'application/json');
    }
    if (!(options === null || options === void 0 ? void 0 : options.noToken) && authTokenResolver) {
        headers.append('Authorization', `Bearer ${await authTokenResolver()}`);
    }
    return fetch(`${baseUrl}${url}`, {
        ...init,
        headers,
        signal: controller.signal,
    })
        .then((res) => parseResponse(res))
        .finally(() => {
        clearTimeout(id);
    });
};
